module.exports = __webpack_public_path__ + "cancellara-dist/img/giftcard-modal.f6146733.jpg";